// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7020c4cdffbc0d672689","655":"d8020f36e5918e887c19"}[chunkId] + ".js";
};